import { methods } from '@/utils/methods'

// 最近チェックした施設情報

const state = () => ({
  // 施設コード情報
  codes: [],
  // 一覧情報
  list: []
})

const getters = {
  codes: (state) => state.codes,
  list: (state) => state.list
}

const mutations = {
  codes(state, codes) {
    state.codes = codes
  },
  list(state, list) {
    state.list = list
  }
}

const actions = {
  // SSR時にlocalStorageを参照する
  async nuxtClientInit(context) {
    let codes = []
    if (process.browser && localStorage.getItem('kcs_history')) {
      try {
        codes = JSON.parse(localStorage.getItem('kcs_history'))
      } catch (e) {
        localStorage.removeItem('kcs_history')
      }
    }
    context.commit('codes', codes)
    await context.dispatch('list')
  },
  // チェックした施設コードをセット
  add(context, id) {
    if (process.browser) {
      const historyMaxCount = Number(process.env.HISTORY_MAX)
      const codes = [...context.getters.codes]

      // 最近チェックした施設情報に該当施設が含まれている場合は、削除する
      const col = codes.indexOf(id)
      if (col > -1) {
        codes.splice(col, 1)
      }

      // 最近チェックした施設情報が { historyMaxCount } 件に達しているかどうか
      if (codes.length >= historyMaxCount) {
        codes.splice(-0, codes.length - historyMaxCount + 1)
      }
      codes.unshift(id)

      localStorage.setItem('kcs_history', JSON.stringify(codes))
      context.commit('codes', codes)
      context.dispatch('list')
    }
  },
  // チェックした施設情報一覧をセット
  async list(context) {
    const codes = context.getters.codes

    const params = {
      facility_code: codes.join(','),
      limit: process.env.HISTORY_MAX
    }

    let res = { data: {} }
    if (params.facility_code.length) {
      res = await this.$axios.get(methods.getApiBaseUrl() + '/facilities', {
        params
      })
    }

    // チェックした順の降順に並べ替える
    let list = []
    if (res.data.facilities) {
      list = codes.map((code) =>
        res.data.facilities.find((facility) => facility.code === code)
      )
      // 見つからなかったcodeは除外
      list = list.filter((facility) => {
        if (facility) return true
        return false
      })
    }
    context.commit('list', list)
  },
  // チェックした施設コードを削除
  async delete(context, id) {
    /* istanbul ignore next */
    if (process.browser) {
      const codes = context.getters.codes
      const filteredCodes = codes.filter((code) => code !== id)
      localStorage.setItem('kcs_history', JSON.stringify(filteredCodes))
      context.commit('codes', filteredCodes)

      await context.dispatch('list')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
